/**
 * Formatação de tamanho de arquivo e cálculo de redução.
 *
 * formatBytes(0)            → "0 B"
 * formatBytes(740)          → "740 B"
 * formatBytes(1024)         → "1.0 KB"
 * formatBytes(1234)         → "1.2 KB"
 * formatBytes(5_242_880)    → "5.0 MB"  (5 MB)
 * formatBytes(1_073_741_824)→ "1.0 GB"
 *
 * reductionPct(orig, comp)  → number inteiro (68 = 68% de redução)
 *                              negativo se comprimido ficou MAIOR
 */

const KB = 1024;
const MB = 1024 * 1024;
const GB = 1024 * 1024 * 1024;

/**
 * Formata bytes em string legível.
 * @param {number} bytes
 * @returns {string}
 */
export function formatBytes(bytes) {
  if (!Number.isFinite(bytes) || bytes < 0) return '0 B';
  if (bytes < KB) return `${bytes} B`;
  if (bytes < MB) {
    const kb = bytes / KB;
    return `${trimDecimals(kb, kb < 10)} KB`;
  }
  if (bytes < GB) {
    const mb = bytes / MB;
    return `${trimDecimals(mb, mb < 10)} MB`;
  }
  const gb = bytes / GB;
  return `${trimDecimals(gb, gb < 10)} GB`;
}

/**
 * Calcula percentual de redução de tamanho.
 * @param {number} original
 * @param {number} compressed
 * @returns {number} arredondado (positivo = redução, negativo = cresceu)
 */
export function reductionPct(original, compressed) {
  if (!Number.isFinite(original) || original <= 0) return 0;
  if (!Number.isFinite(compressed) || compressed < 0) return 0;
  return Math.round(((original - compressed) / original) * 100);
}

/**
 * Truncar casas decimais: 1 casa se < 10, 0 casas se >= 10.
 * Ex: 1.234 → "1.2", 12.345 → "12".
 */
function trimDecimals(value, oneDecimal) {
  if (oneDecimal) return value.toFixed(1);
  return Math.round(value).toString();
}
